/* notification start */
export const NEW_NOTICE = 'NEW_NOTICE'
export const CLOSE_NOTICE = 'CLOSE_NOTICE'
/* notification end */

/* user start */
export const SHOW = 'SHOW'
export const STORE = 'STORE'
export const ACCOUNT = 'ACCOUNT'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_SYSTEM_MESSAGES = 'SET_SYSTEM_MESSAGES'
export const SET_USER_MESSAGES = 'SET_USER_MESSAGES'
/* user end */

/* captcha start */
export const SET_CAPTCHA = 'SET_CAPTCHA'
export const CLEAR_CAPTCHA = 'CLEAR_CAPTCHA'
export const SET_CAPTCHA_ERROR = 'SET_CAPTCHA_ERROR'
export const CLEAR_CAPTCHA_ERROR = 'CLEAR_CAPTCHA_ERROR'
export const CHANGE_CAPTCHA = 'CHANGE_CAPTCHA'
/* captcha end */



// WEBPACK FOOTER //
// ./src/store/mutation-types.js